export default __webpack_public_path__ + "static/image_evenement_s@2x-5d689903db3d1ec04481069eb93a5749.jpg";